import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { supabase } from '../supabase'
import NavbarPublico from '../components/NavbarPublico'
import FooterLegal from '../components/FooterLegal'

function Registro({ onRegistroExitoso, onIrALogin, onIrAInicio }) {
  const [nombre, setNombre] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState('')
  const [registroExitoso, setRegistroExitoso] = useState(false)
  const [passwordValido, setPasswordValido] = useState({ largo: false, mayuscula: false, numero: false, simbolo: false })
  const [verPassword, setVerPassword] = useState(false)

  function validarPassword(valor) {
    setPassword(valor)
    setPasswordValido({
      largo: valor.length >= 8,
      mayuscula: /[A-Z]/.test(valor),
      numero: /[0-9]/.test(valor),
      simbolo: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(valor),
    })
  }

  const passwordOk = passwordValido.largo && passwordValido.mayuscula && passwordValido.numero && passwordValido.simbolo

  async function handleRegistro(e) {
    e.preventDefault()
    if (!passwordOk) {
      setError('La contraseña no cumple los requisitos.')
      return
    }
    setCargando(true)
    setError('')
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { nombre } }
    })
    if (error) {
      setError('Error al crear la cuenta. Verifica tus datos e inténtalo de nuevo.')
      setCargando(false)
      return
    }
    setRegistroExitoso(true)
    setCargando(false)
  }

  if (registroExitoso) {
    return (
      <div style={estilos.pagina}>
        <NavbarPublico onIrALogin={onIrALogin} onIrAInicio={onIrAInicio} vistaActiva='registro' />
        <div style={estilos.contenidoPagina}>
          <div style={estilos.caja}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📬</div>
            <h2 style={estilos.titulo}>Revisa tu email</h2>
            <p style={{ fontSize: '15px', color: '#5C4033', lineHeight: '1.7', textAlign: 'center', marginBottom: '8px' }}>
              Te hemos enviado un enlace de confirmación a:
            </p>
            <p style={{ fontSize: '16px', fontWeight: '700', color: '#2C1810', textAlign: 'center', marginBottom: '24px' }}>
              {email}
            </p>
            <div style={{ backgroundColor: '#F0F4E8', border: '1px solid #C8D5A0', borderRadius: '10px', padding: '16px', marginBottom: '24px', fontSize: '13px', color: '#3D4D1F', lineHeight: '1.7' }}>
              <strong>⚠️ Importante:</strong> Debes confirmar tu email antes de
              poder iniciar sesión. Revisa tu bandeja de entrada y también
              la carpeta de <strong>spam o correo no deseado</strong> si no
              lo ves en unos minutos.
            </div>
            <button onClick={onIrALogin} style={{ width: '100%', padding: '13px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>
              Ir a iniciar sesión
            </button>
          </div>
        </div>
        <FooterLegal />
      </div>
    )
  }

  return (
    <div style={estilos.pagina}>
      <NavbarPublico onIrALogin={onIrALogin} onIrAInicio={onIrAInicio} vistaActiva='registro' />
      <div style={estilos.contenidoPagina}>
        <div style={estilos.caja}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logo-circulo.png" alt="Etern-me" style={estilos.logo} />
          </a>
          <h2 style={estilos.titulo}>Crea tu espacio seguro</h2>
          <p style={estilos.subtitulo}>14 días de prueba gratis · Sin tarjeta de crédito</p>

          {error && <div style={estilos.error}>{error}</div>}

          <form onSubmit={handleRegistro} style={{ width: '100%' }}>
            <div style={estilos.campo}>
              <label style={estilos.label}>Nombre completo</label>
              <input type="text" value={nombre} onChange={e => setNombre(e.target.value)}
                style={estilos.input} placeholder="Tu nombre" required />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                style={estilos.input} placeholder="tu@email.com" required />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Contraseña</label>
              <div style={{ position: "relative", width: "100%" }}><input type={verPassword ? "text" : "password"} value={password} onChange={e => validarPassword(e.target.value)} style={{...estilos.input, paddingRight: "40px"}} placeholder="Crea tu contraseña" required /><button type="button" onClick={() => setVerPassword(!verPassword)} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#8B6F47", fontSize: "16px" }}>{verPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button></div>







              {password.length > 0 && (
                <div style={{ fontSize: '12px', marginTop: '6px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <span style={{ color: passwordValido.largo ? '#5C6B3A' : '#8B6F47' }}>
                    {passwordValido.largo ? '✓' : '○'} Mínimo 8 caracteres
                  </span>
                  <span style={{ color: passwordValido.mayuscula ? '#5C6B3A' : '#8B6F47' }}>
                    {passwordValido.mayuscula ? '✓' : '○'} Al menos una mayúscula
                  </span>
                  <span style={{ color: passwordValido.numero ? '#5C6B3A' : '#8B6F47' }}>
                    {passwordValido.numero ? '✓' : '○'} Al menos un número
                  </span>
                  <span style={{ color: passwordValido.simbolo ? '#5C6B3A' : '#8B6F47' }}>
                    {passwordValido.simbolo ? '✓' : '○'} Al menos un símbolo (!@#$...)
                  </span>
                </div>
              )}
            </div>
            <button type="submit" disabled={cargando || !passwordOk}
              style={{ ...estilos.boton, opacity: (cargando || !passwordOk) ? 0.7 : 1 }}>
              {cargando ? 'Creando cuenta...' : 'Empezar mi prueba gratis'}
            </button>
          </form>

          <p style={estilos.terminos}>
            Al registrarte aceptas que tus datos se almacenan de forma segura y privada.
            Nunca los compartimos con terceros.
          </p>
          <p style={estilos.enlace}>
            ¿Ya tienes cuenta?{' '}
            <span onClick={onIrALogin} style={estilos.link}>Inicia sesión</span>
          </p>
        </div>
      </div>
      <FooterLegal />
    </div>
  )
}

const estilos = {
  pagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', flexDirection: 'column' },
  contenidoPagina: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 16px' },
  caja: { backgroundColor: '#FFFFFF', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '420px', border: '1px solid #E8E0D5', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  logo: { width: '100px', height: '100px', objectFit: 'contain', marginBottom: '20px' },
  titulo: { fontSize: '22px', fontWeight: '700', color: '#2C1810', textAlign: 'center', marginBottom: '6px', letterSpacing: '-0.3px' },
  subtitulo: { fontSize: '14px', color: '#8B6F47', textAlign: 'center', marginBottom: '28px', fontWeight: '500' },
  campo: { marginBottom: '16px', width: '100%' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#2C1810', marginBottom: '6px' },
  input: { width: '100%', padding: '12px 14px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '15px', outline: 'none', backgroundColor: '#FAF8F5', color: '#2C1810' },
  requisitos: { marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '4px' },
  requisito: { fontSize: '12px', transition: 'color 0.2s' },
  boton: { width: '100%', padding: '14px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '4px' },
  error: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', border: '1px solid #F5C9B8', width: '100%' },
  terminos: { fontSize: '12px', color: '#8B6F47', textAlign: 'center', marginTop: '16px', lineHeight: '1.6' },
  enlace: { textAlign: 'center', fontSize: '14px', color: '#8B6F47', marginTop: '16px' },
  link: { color: '#2C1810', fontWeight: '600', cursor: 'pointer', textDecoration: 'underline' },
}

export default Registro